(function () {
  'use strict';

  var AUTOPLAY_MS = 5500;

  function parseVideo(raw) {
    if (!raw) return null;
    var value = String(raw).trim();

    var youtubeMatch = value.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{11})/i);
    if (youtubeMatch) return { provider: 'youtube', id: youtubeMatch[1] };

    var vimeoMatch = value.match(/vimeo\.com\/(?:video\/)?(\d+)/i);
    if (vimeoMatch) return { provider: 'vimeo', id: vimeoMatch[1] };

    if (/^\d+$/.test(value)) return { provider: 'vimeo', id: value };
    if (/^[\w-]{11}$/.test(value)) return { provider: 'youtube', id: value };

    return null;
  }

  function buildEmbedUrl(video) {
    if (video.provider === 'youtube') {
      return 'https://www.youtube.com/embed/' + encodeURIComponent(video.id) + '?autoplay=1&rel=0';
    }
    return (
      'https://player.vimeo.com/video/' +
      encodeURIComponent(video.id) +
      '?playsinline=0&autoplay=1&muted=0&badge=0&autopause=0&title=0&byline=0&portrait=0&app_id=58479'
    );
  }

  function initQuotes(root) {
    var region = root.querySelector('[data-hp-hero-quotes]');
    if (!region) return;

    var track = region.querySelector('[data-hp-hero-track]');
    var slides = Array.prototype.slice.call(region.querySelectorAll('[data-hp-hero-slide]'));
    if (!track || slides.length < 2) return;

    var index = 0;
    var timer = null;

    function setActive(next) {
      index = (next + slides.length) % slides.length;

      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        if (active) {
          slide.removeAttribute('inert');
        } else {
          slide.setAttribute('inert', '');
        }
      });
    }

    function start() {
      stop();
      timer = window.setInterval(function () {
        setActive(index + 1);
      }, AUTOPLAY_MS);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    region.addEventListener('mouseenter', stop);
    region.addEventListener('mouseleave', start);
    region.addEventListener('focusin', stop);
    region.addEventListener('focusout', start);

    setActive(0);
    start();
  }

  function initVideo(root) {
    var sectionId = root.getAttribute('data-section-id') || '';
    var modal =
      root.querySelector('[data-hp-hero-dialog]') ||
      (sectionId
        ? document.querySelector('[data-hp-hero-dialog][data-section-id="' + sectionId + '"]')
        : null);
    var openers = root.querySelectorAll('.hp-hero__video-btn');
    if (!modal || !openers.length) return;

    var mount = modal.querySelector('[data-hp-hero-video-mount]');
    var closers = modal.querySelectorAll('.hp-hero__modal-close');
    if (!mount) return;

    var video = parseVideo(root.getAttribute('data-video-url'));
    var iframe = null;
    var lastFocus = null;
    var sentinelStart = null;
    var sentinelEnd = null;
    var inertedNodes = [];

    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    function focusables() {
      return Array.prototype.slice
        .call(modal.querySelectorAll('button, [href], iframe, input, select, textarea, [tabindex]'))
        .filter(function (el) {
          return !el.hasAttribute('data-hp-hero-sentinel') && el.tabIndex > -1 && !el.disabled;
        });
    }

    function ensureSentinels() {
      if (sentinelStart) return;

      sentinelStart = document.createElement('div');
      sentinelEnd = document.createElement('div');

      [sentinelStart, sentinelEnd].forEach(function (node) {
        node.tabIndex = 0;
        node.setAttribute('data-hp-hero-sentinel', '');
        node.setAttribute('aria-hidden', 'true');
      });

      modal.insertBefore(sentinelStart, modal.firstChild);
      modal.appendChild(sentinelEnd);

      sentinelStart.addEventListener('focus', function () {
        var list = focusables();
        if (list.length) list[list.length - 1].focus();
      });

      sentinelEnd.addEventListener('focus', function () {
        var list = focusables();
        if (list.length) list[0].focus();
      });
    }

    function setBackgroundInert(on) {
      if (on) {
        inertedNodes = [];
        Array.prototype.forEach.call(document.body.children, function (node) {
          if (node === modal || node.hasAttribute('inert')) return;
          node.setAttribute('inert', '');
          inertedNodes.push(node);
        });
        return;
      }

      inertedNodes.forEach(function (node) {
        node.removeAttribute('inert');
      });
      inertedNodes = [];
    }

    function ensureIframe() {
      if (iframe || !video) return;
      iframe = document.createElement('iframe');
      iframe.src = buildEmbedUrl(video);
      iframe.title = "Innovator's Journey: Nicholas Hool | Drug-Free Anti-Anxiety | #AZweartech";
      iframe.setAttribute(
        'allow',
        'autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share'
      );
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('frameborder', '0');
      mount.appendChild(iframe);
    }

    function clearIframe() {
      if (!iframe) return;
      iframe.remove();
      iframe = null;
      mount.innerHTML = '';
    }

    function openModal() {
      if (!video) return;
      lastFocus = document.activeElement;
      ensureIframe();
      ensureSentinels();
      modal.hidden = false;
      modal.classList.add('is-open');
      document.body.classList.add('hp-hero-modal-open');
      setBackgroundInert(true);
      var closeBtn = modal.querySelector('.hp-hero__modal-close');
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.hidden = true;
      document.body.classList.remove('hp-hero-modal-open');
      setBackgroundInert(false);
      clearIframe();
      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
    }

    if (modal.getAttribute('data-hp-hero-video-bound') !== 'true') {
      modal.setAttribute('data-hp-hero-video-bound', 'true');

      closers.forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          closeModal();
        });
      });

      modal.addEventListener('click', function (event) {
        if (event.target === modal) closeModal();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && modal.classList.contains('is-open')) {
          closeModal();
        }
      });
    }

    openers.forEach(function (btn) {
      if (btn.getAttribute('data-hp-hero-open-bound') === 'true') return;
      btn.setAttribute('data-hp-hero-open-bound', 'true');
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        openModal();
      });
    });
  }

  function initHero(root) {
    if (!root || root.getAttribute('data-hp-hero-ready') === 'true') return;
    root.setAttribute('data-hp-hero-ready', 'true');
    initQuotes(root);
    initVideo(root);
  }

  function boot() {
    document.querySelectorAll('[data-hp-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-hp-hero]');
    if (root) {
      root.removeAttribute('data-hp-hero-ready');
      initHero(root);
    }
  });
})();
